import React from 'react';
import './PoweredBy.css'

const PoweredBy = () => (
  <div className="powered-by">
    powered by<br/>
    <img src="./images/Logo.svg" alt="Translated"/>
  </div>
)

export default PoweredBy